export default [
  {
    path: "",
    name: "notification-list",
    component: () => import("@/view/pages/notifications/NotificationList"),
  },
];
